// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        scrollingModule: action.scrollingModule
      };
    },
    SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.scrollingModule
      };
    },
    SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.scrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
